import fuelFoundationTheme from '@frete.com/fuel-foundation/fretepago/theme.json';
import colors from './colors';

const theme = {
  ...fuelFoundationTheme,
  color: colors,
};

export default theme;
